import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["description"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React, { forwardRef } from 'react';
import useUniqueId from 'hooks/useUniqueId';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var MarkdownIcon = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var description = _ref.description,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var descriptionId = useUniqueId();
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, otherProps), {}, {
    ref: ref,
    role: "img",
    viewBox: "0 0 208 128",
    style: {
      fill: 'currentcolor',
      width: 26,
      height: 16
    },
    "aria-label": "Markdown",
    "aria-describedby": descriptionId,
    children: [/*#__PURE__*/_jsx("desc", {
      id: descriptionId,
      children: description
    }), /*#__PURE__*/_jsx("path", {
      role: "presentation",
      d: "M208,25c0,-13.798 -11.202,-25 -25,-25c0,0 -158,0 -158,0c-13.798,0 -25,11.202 -25,25c0,0 0,78 0,78c0,13.798 11.202,25 25,25l158,0c13.798,0 25,-11.202 25,-25c0,-0 0,-78 0,-78Zm-10,0l0,78c0,8.279 -6.721,15 -15,15c0,0 -158,0 -158,0c-8.279,0 -15,-6.721 -15,-15l0,-78c0,-8.279 6.721,-15 15,-15l158,0c8.279,0 15,6.721 15,15Z"
    }), /*#__PURE__*/_jsx("path", {
      role: "presentation",
      d: "M30,98l0,-68l20,0l20,25l20,-25l20,0l0,68l-20,0l0,-39l-20,25l-20,-25l0,39l-20,0Zm125,0l-30,-33l20,0l0,-35l20,0l0,35l20,0l-30,33Z"
    })]
  }));
});
MarkdownIcon.displayName = 'MarkdownIcon';
export default MarkdownIcon;